import React, { useEffect, useState } from 'react';
import { signInWithEmailAndPassword, onAuthStateChanged  } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom'
import '../styles/Login.css';

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    // Redireciona para "/" se o usuário já estiver logado
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                navigate("/");
            }
        });

        // Limpeza do listener
        return () => unsubscribe();
    }, [navigate]);

    const onLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                navigate("/")
      
            })
            .catch((error) => {
                console.error("codigo do erro: ",error.code," ",error.message); 
            });

    }

    return (
        <div className='main-container-login' >
            <div className='container-login'>
                <p className='titulo-login'>
                    <strong>Login</strong>
                </p>
                <form>
                    <div className='label-login'>
                        <input
                            className='input-login'
                            id="email-address"
                            name="email"
                            type="email"
                            required
                            placeholder="Email address"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className='label-login'>

                        <input
                            className='input-login'
                            id="password"
                            name="password"
                            type="password"
                            required
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className='label-login'>
                        <button
                            className='btn-login'
                            onClick={onLogin}
                        >
                            Login
                        </button>
                    </div>
                </form>

                {/*  <p className="text-sm text-white text-center">
                    Não tem conta ainda? {' '}
                    <NavLink to="/cadastro">
                        Cadastre-se
                    </NavLink>
                </p>    */}
            </div>
        </div>
    )
}

export default Login